import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllSchools(_obj, params) {
    const res = await axios.get('api/schools/', { params });
    return res.data;
  },
  async getSchool(_obj, id) {
    const res = await axios.get(`api/schools/${id}/`);
    return res.data;
  },
  async createSchool(_obj, data) {
    const res = await axios.post('api/schools/', data);
    return res.data;
  },
  async updateSchool(_obj, { id, data }) {
    const res = await axios.patch(`api/schools/${id}/`, data);
    return res.data;
  },
};

export const school = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
